import { render, staticRenderFns } from "./TranslationScreen.vue?vue&type=template&id=15ea1e35&scoped=true"
import script from "./TranslationScreen.vue?vue&type=script&lang=ts"
export * from "./TranslationScreen.vue?vue&type=script&lang=ts"
import style0 from "./TranslationScreen.vue?vue&type=style&index=0&id=15ea1e35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ea1e35",
  null
  
)

export default component.exports